export function pageBuilderForMilli(page) {
  return {
    id: page.id,
    pageNumber: page.page_number,
    pageName: page.page_name,
    thumbnailUri: page.thumbnail_uri,
  };
}
